const key = 'remembered-login'

export function clearRememberedCredentials() {
  window.localStorage.removeItem(key)
}

export async function readRememberedCredentials() {
  try {
    const encrypted = window.localStorage.getItem(key)
    if (!encrypted || !window.appEnv || !window.appEnv.decryptCredentials) return null
    const value = JSON.parse(await window.appEnv.decryptCredentials(encrypted))
    if (typeof value.username !== 'string' || typeof value.password !== 'string') throw Error('Invalid credentials')
    return { username: value.username, password: value.password }
  } catch (_) {
    clearRememberedCredentials()
    return null
  }
}

export async function saveRememberedCredentials(credentials) {
  clearRememberedCredentials()
  if (!window.appEnv || !window.appEnv.encryptCredentials) throw Error('请在桌面客户端中使用记住密码')
  const encrypted = await window.appEnv.encryptCredentials(JSON.stringify(credentials))
  window.localStorage.setItem(key, encrypted)
}
